import http from "../../../Utils/http";

    export function PaymentData(data, type, page) {
      return http.get(`api/payout/user?type=${type}&today=${data.today}&last_30_days=${data.last_30_days}&financial_year=${data.financial_year}&custom[start_date]=${data.start_date}&custom[end_date]=${data.end_date}&page=${page}`)
    }

    export function PaymentDataId(data) {
      return http.get(`api/payout/user/record?type=${data.type}&id=${data.id}`)
    }